/**
 * Italian display formatter for ISO-style date strings.
 *
 * Input  accepted:
 *   - "YYYY-MM-DD"               (storage / API)
 *   - "YYYY-MM-DDTHH:mm:ss[.fff][Z]"  (timestamps with time)
 *   - falsy / invalid            → returned as-is (so it's safe to wrap any value)
 *
 * Output: "DD/MM/YYYY"
 *
 * NOTE: We do NOT touch backend payloads, MongoDB documents or
 * <input type="date"> values — those must stay ISO. This helper is for
 * UI display only.
 */
export function formatDateIT(value) {
  if (!value || typeof value !== "string") return value ?? "";
  const m = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return value;
  const [, y, mo, d] = m;
  return `${d}/${mo}/${y}`;
}
